import { createComponent } from '@lit-labs/react';
import React from 'react';
import Dsy from './dsyui';

const LitComp = Dsy.components.DsyClickableIcon;

export const DsyClickableIcon = createComponent(
  React,
  'dsy-clickable-icon',
  LitComp,
  {},
);
